import React, {
  useCallback, useContext, useState
} from 'react';
import { useNavigate } from 'react-router-dom';

import {
  AssetDistributionOption, ButtonBar, ScreenHeader
} from '../../components';
import { useScrollToTop } from '../../hooks';

import { NewPOAContext } from './new-poa-composer';

export function NewPOAInsuranceAnnuity() {
  const { powerOfAttorney, setPowerOfAttorney } = useContext(NewPOAContext);
  const navigate = useNavigate();
  const [ insuranceAnnuity, setInsuranceAnnuity ] = useState(powerOfAttorney.insurance_annuity || false);
  
  useScrollToTop();
  
  const handleBack = useCallback(() => {
    navigate('../securities');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    setPowerOfAttorney(prev => ({ 
      ...prev, 
      insurance_annuity: insuranceAnnuity
    }));
    navigate('../retirement-plans');
  }, [ insuranceAnnuity, setPowerOfAttorney, navigate ]);
  
  return (
    <div className="new-poa-insurance-annuity screen-container screen">
      <ScreenHeader
        title="Insurance & Annuity Transactions"
        description="Decide whether to grant your agent power over insurance and annuities"
        handleBack={handleBack}
      />
      
      <div className="content-section">
        <h3>What Are Insurance & Annuity Powers?</h3>
        <p>
          Insurance and annuity powers allow your agent to manage your insurance policies 
          and annuity contracts. This includes:
        </p>
        <ul className="insurance-list">
          <li>Life insurance policies</li>
          <li>Health insurance coverage</li>
          <li>Property and casualty insurance</li>
          <li>Disability insurance</li>
          <li>Long-term care insurance</li>
          <li>Annuity contracts and investments</li>
          <li>Insurance premium payments</li>
        </ul>

        <h3>What Your Agent Can Do</h3>
        <p>If you grant this power, your agent can:</p>
        <ul className="agent-powers">
          <li>Apply for and purchase insurance policies</li>
          <li>Pay insurance premiums and fees</li>
          <li>File insurance claims on your behalf</li>
          <li>Change beneficiaries on policies</li>
          <li>Surrender or borrow against life insurance</li>
          <li>Purchase or surrender annuity contracts</li>
          <li>Receive insurance proceeds and benefits</li>
        </ul>

        <h3>Do You Want to Grant This Power?</h3>
        <div className="asset-distribution-option-container">
          <AssetDistributionOption
            id="insurance-annuity-yes"
            label="Yes"
            description="Grant power over insurance and annuities"
            value="yes"
          />
          <AssetDistributionOption
            id="insurance-annuity-no"
            label="No"
            description="Do not grant power over insurance and annuities"
            value="no"
          />
        </div>

        <div className="important-note">
          <h4>Important:</h4>
          <p>
            Insurance and annuity powers can affect your financial security and beneficiaries. 
            Your agent will be able to make changes that could impact your coverage and 
            the benefits paid to your loved ones.
          </p>
        </div>
      </div>

      <ButtonBar 
        handlePrimary={handleNext}
        primaryText="Continue"
      />
    </div>
  );
}
